/**
 * Narrowing helpers for `catch` blocks.
 *
 * With `strict` on, a caught value is `unknown`, and the codebase was full of
 * `error.message` reads that only compiled because type checking never ran.
 */

/** A human-readable message for anything thrown. */
export function errorMessage(error: unknown, fallback = 'Unknown error'): string {
  if (error instanceof Error) return error.message;
  if (typeof error === 'string') return error;
  if (error && typeof error === 'object' && 'message' in error) {
    const message = (error as { message: unknown }).message;
    if (typeof message === 'string') return message;
  }
  return fallback;
}

/** True for the DOMException an AbortController raises, which is not a failure. */
export function isAbortError(error: unknown): boolean {
  return error instanceof DOMException && error.name === 'AbortError';
}
